import styled from 'styled-components'

const Bar = styled.div`
  flex-grow: 1;
`

export default Bar
